<template>
  <div class="home">

    <div class="notes-list grid">
      <div class="notes-list__item col col--580-6 col--1024-4 col--1366-3"
        v-for="note in notes"
        :key="note.id"
      >
        <note
          :title="note.title"
          :todos="note.todos"
          readonly
          @click.native="onNoteClick(note.id)"
          @delete="onNoteDelete(note.id)"
        />
      </div>
    </div>

    <no-notes
      class="home__no-notes"
      v-if="noNotes"
    />

    <btn-add
      class="home__btn-add"
      @click="onCreate"
      :animate="noNotes"
    />

    <modal
      v-model="deleteModal"
      @confirm="onDeleteModalConfirm"
      title="Why?"
      text="Really delete note?"
    />
  </div>
</template>

<script>
import Note from '@/components/Note'
import BtnAdd from '@/components/BtnAdd'
import Modal from '@/components/Modal'
import NoNotes from '@/components/home/NoNotes'

export default {
  name: 'Home',

  components: {
    Modal,
    Note,
    BtnAdd,
    NoNotes
  },

  data: () => ({
    deleteModal: false,
    idNoteForDelete: null
  }),

  computed: {
    notes() {
      return this.$store.getters.allNotes
    },

    noNotes() {
      return this.$store.getters.notesCount === 0
    }
  },

  methods: {
    onCreate() {
      this.$router.push({ name: 'note' })
    },

    onNoteClick(noteId) {
      this.$router.push({ name: 'note', params: { id: noteId } })
    },

    onNoteDelete(id) {
      this.deleteModal = true
      this.idNoteForDelete = id
    },

    onDeleteModalConfirm() {
      this.$store.commit('deleteNote', this.idNoteForDelete)
      this.$store.dispatch('saveNotes')
    }
  }
}
</script>

<style lang="stylus" scoped>
.home

  &__btn-add
    position fixed
    bottom 20px
    right 20px

    &:hover
      transform rotate(90deg)

  &__no-notes
    position fixed
    top 0
    right 0
    bottom 0
    left 0
    z-index -1

.notes-list
  margin 0 -12px -12px

  &__item
    padding 12px
    display flex
</style>
